import { render, staticRenderFns } from "./popUpModal.vue?vue&type=template&id=7da51f13&"
import script from "./popUpModal.vue?vue&type=script&lang=js&"
export * from "./popUpModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports